<div
  class="physical-credential d-flex flex-column align-items-center h-100 w-100 justify-content-center px-4 py-4 modal-main"
>
  <div class="header w-100">
    <div class="d-flex justify-content-between">
      <span class="col-2 d-flex flex-row align-items-center">
        <img
          src="/assets/svg/ico-chevron-back-outline.svg"
          alt="back button"
          class="pointer-cursor"
          (click)="navigateBack()"
        />
      </span>
      <div class="d-flex flex-column justify-content-center col-8">
        <span class="user-title m-auto col-6">
          <app-with-tooltip [showHelpCursor]="true">
            {{ this.formInstance?.name?.value }}
          </app-with-tooltip>
        </span>    
        <span class="modal-title m-auto">{{
          'STANDARD_CREDENTIAL' | translate
        }}</span>
      </div>
      <span class="col-2 d-flex flex-row align-items-center justify-content-end pr-2">
        <img
          src="/assets/svg/ico-hamburger-close.svg"
          class="cross-button pointer-cursor"
          (click)="closeDialog()"
        />
      </span>
    </div>
  </div>
  <div
    class="d-flex flex-column justify-content-start w-100 px-3 form-container"
  >
    <ng-container *ngIf="step === 1 && userCredentials?.length !== 0">
      <app-user-physical-credentials-list
        [userCredentials]="userCredentials"
        (credentials)="setSelectedCredentials($event)"
        [(step)]="step"
      ></app-user-physical-credentials-list>
    </ng-container>

    <ng-container *ngIf="userCredentials?.length === 0 && step === 1">
      <app-no-user-profile-physical-credentials
        [userName]="this.formInstance?.name?.value"
      ></app-no-user-profile-physical-credentials>
    </ng-container>

    <div *ngIf="step === 1" class="info-banner d-flex align-items-center">
      <img src="/assets/svg/ico-info-blue.svg" class="info-icon" alt="Info" />
      <span class="info-text">{{ 'STANDARD_CREDENTIAL_INFO' | translate }}</span>
    </div>

    <ng-container *ngIf="userCredentials?.length > 0 && step === 2">
      <app-view-user-physical-credentials
        [selectedCredentials]="selectedCredentials"
        [(step)]="step"
      ></app-view-user-physical-credentials>
    </ng-container>

    <ng-container *ngIf="step === 3">
      <app-user-physical-credentials-access
        [selectedCredentials]="selectedCredentials"
      >
      </app-user-physical-credentials-access>
    </ng-container>
  </div>
</div>
